// extracted by mini-css-extract-plugin
export default {"bar":"browsies-module__bar___KmM2k","title":"browsies-module__title___atFUt","selected":"browsies-module__selected___ujbGV","mobile":"browsies-module__mobile___Apb5t"};